var map = {
	"./leadershipSM1.jpg": 36066,
	"./leadershipSM2.jpg": 35690,
	"./leadershipSM3.jpg": 22091,
	"./leadershipSM4.jpg": 56135,
	"./leadershipSM5.jpg": 70706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97059;